import React, { useState } from "react";
import { useAuth } from "../../hooks/useAuth";

const LoginForm: React.FC = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const { login, isLoading } = useAuth();

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError("");

    if (!email || !password) {
      setError("Please enter both email and password");
      return;
    }

    const success = await login(email, password);
    if (!success) {
      setError("Invalid email or password");
    }
  };

  const containerStyle: React.CSSProperties = {
    minHeight: "100vh",
    background: "linear-gradient(135deg, #E0F7FA 0%, #80DEEA 100%)",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    padding: "16px",
  };

  const formStyle: React.CSSProperties = {
    background: "#ffffff",
    borderRadius: "16px",
    boxShadow: "0 25px 50px rgba(0,0,0,0.15)",
    padding: "48px",
    width: "100%",
    maxWidth: "400px",
  };

  const titleStyle: React.CSSProperties = {
    fontSize: "28px",
    fontWeight: "bold",
    color: "#1e293b",
    marginBottom: "8px",
    textAlign: "center",
  };

  const subtitleStyle: React.CSSProperties = {
    color: "#64748b",
    fontSize: "16px",
    textAlign: "center",
    marginBottom: "32px",
  };

  const inputStyle: React.CSSProperties = {
    width: "100%",
    padding: "14px 18px",
    border: "2px solid #e5e7eb",
    borderRadius: "12px",
    fontSize: "16px",
    marginBottom: "16px",
    outline: "none",
    transition: "border-color 0.2s ease",
  };

  const buttonStyle: React.CSSProperties = {
    width: "100%",
    padding: "14px",
    background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
    color: "white",
    border: "none",
    borderRadius: "12px",
    fontSize: "16px",
    fontWeight: "600",
    cursor: isLoading ? "not-allowed" : "pointer",
    opacity: isLoading ? 0.7 : 1,
    transition: "all 0.2s ease",
  };

  const errorStyle: React.CSSProperties = {
    color: "#ef4444",
    fontSize: "14px",
    marginBottom: "16px",
    padding: "12px",
    background: "#fef2f2",
    border: "1px solid #fecaca",
    borderRadius: "8px",
  };

  return (
    <div style={containerStyle}>
      <form onSubmit={handleSubmit} style={formStyle}>
        <div style={titleStyle}>Welcome to Caduceus</div>
        <div style={subtitleStyle}>Please sign in to continue</div>

        {error && <div style={errorStyle}>{error}</div>}

        <input
          type="email"
          id="email"
          name="email"
          placeholder="Email address"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          style={inputStyle}
          required
          autoComplete="email"
        />

        <input
          type="password"
          id="password"
          name="password"
          placeholder="Password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          style={inputStyle}
          required
          autoComplete="current-password"
        />

        <button type="submit" disabled={isLoading} style={buttonStyle}>
          {isLoading ? "Signing in..." : "Sign In"}
        </button>
      </form>
    </div>
  );
};

export default LoginForm;
